import React from 'react';
import { Switch, Route, NavLink } from 'react-router-dom';

import './App.css';

import { ReactComponent as Logo } from './flowli_logo-vektor.svg';
import { ReactComponent as PMLogo } from './PMLogo.svg';
import Imprint from './components/Imprint';
import PrivacyPolicy from './components/PrivacyPolicy';
import SoundCards from './components/SoundCards';
import Rain from './components/Rain';
import Thunder from './components/Thunder';
import Wind from './components/Wind';
import Night from './components/Night';
import Fire from './components/Fire';
import Seaside from './components/Seaside';
import Stream from './components/Stream';
import Garden from './components/Garden';

function App() {
  return (
    <div className="App">
      <nav className="navbar">
        <Logo className="logo" />
      </nav>
      <Switch>
        <Route exact path="/">
          <SoundCards>
            <Rain />
            <Thunder />
            <Wind />
            <Night />
            <Fire />
            <Seaside />
            <Stream />
            <Garden />
          </SoundCards>
        </Route>
        <Route path="/imprint" component={Imprint} />
        <Route path="/privacy-policy" component={PrivacyPolicy} />
        <Route path="*"></Route>
      </Switch>
      <footer className="footer">
        <NavLink exact to="/">
          Back to the Flow
        </NavLink>
        <NavLink to="/imprint">Imprint</NavLink>
        <NavLink to="/privacy-policy">Privacy Policy</NavLink>
        <a
          href="https://progressive-mind.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <PMLogo style={{ width: '50px' }} />
        </a>
      </footer>
    </div>
  );
}

export default App;
